import api from "./base-api"

const dsSyncConflictsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getSyncConflictsDS: build.query({
            query: ({ stateId, vendorId, page = 0, limit = 25 }) => {
                const p = new URLSearchParams({ page, limit })
                if (stateId && stateId.trim()) p.set("stateId", stateId.trim())
                if (vendorId && vendorId.trim()) p.set("vendorId", vendorId.trim())
                return `v3/ds/sync-conflicts?${p.toString()}`
            },
            providesTags: ["SyncConflictsDS"]
        }),
        getSyncConflictDS: build.query({
            query: (id) => `v3/ds/sync-conflicts/${id}`,
            providesTags: (_r, _e, id) => [{ type: "SyncConflictsDS", id }]
        })
    }),
    overrideExisting: false
})

export const {
    useGetSyncConflictsDSQuery,
    useGetSyncConflictDSQuery
} = dsSyncConflictsApi
